module.exports = __webpack_public_path__ + "img/松花粉.4e000471.jpg";